var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"common-switch"},[(_vm.label)?_c('p',{staticClass:"switch-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('span',{staticClass:"slider"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }